import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PaymentsIcon from "@mui/icons-material/Payments";
import StepProgress from "./StepProgress";
import gb from '../assets/images/gbottom.png';

const PaymentOptions = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#f8f9e9",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        py: 6,
        position: "relative", // Needed for absolute positioning of the image
        minHeight: "100vh", // Ensures the full height to position the image correctly
      }}
    >
      {/* Step Indicator */}
      <StepProgress />

      {/* Title */}
      <Typography variant="h6" className="py-6 text-red-600 font-semibold mb-6">
        Select an option
      </Typography>

      {/* Payment Options */}
      <Box className="space-y-4 w-100">
        <Box className="border border-yellow-500 rounded-md bg-[#f8f9e9] w-full py-3 px-4">
          <Button className="w-full border border-yellow-500 bg-transparent text-black px-4 py-3 rounded-lg">
            <div className="w-full flex items-center justify-start">
              <CreditCardIcon className="text-red-500 mr-2" />
              <Typography className="text-md text-black text-left">
                Prepaid, Debit or Credit Card
              </Typography>
            </div>
          </Button>
        </Box>

        <Box className="border border-yellow-500 rounded-md bg-[#f8f9e9] w-full py-3 px-4">
          <Button className="w-full border border-yellow-500 bg-transparent text-black px-4 py-3 rounded-lg">
            <div className="w-full flex items-center justify-start">
              <PaymentsIcon className="text-green-500 mr-2" />
              <Typography className="text-md text-black text-left">UPI</Typography>
            </div>
          </Button>
        </Box>

        <Box className="border border-yellow-500 rounded-md bg-[#f8f9e9] w-full py-3 px-4">
          <Button className="w-full border border-yellow-500 bg-transparent text-black px-4 py-3 rounded-lg">
            <div className="w-full flex items-center justify-start">
              <AccountBalanceIcon className="text-red-500 mr-2" />
              <Typography className="text-md text-black text-left">Net Banking</Typography>
            </div>
          </Button>
        </Box>
      </Box>

      {/* Footer Image - Positioned Just Above the Footer */}
      <Box
        sx={{
          position: "absolute",
          bottom: "0", // Adjust to move it above the footer
          left: 0,
          width: "400px", // Adjust width as needed
          height: "150px", // Adjust height as needed
          backgroundImage: `url(${gb})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left bottom",
        }}
      />
    </Box>
  );
};

export default PaymentOptions;
